<template>
  <div class="password-requirements">
    <p class="password-requirements__label">Minimum password requirements</p>
    <div class="password-requirements__req">
      <form-checkbox
        class="password-requirements__6plus"
        name="password-requirements-min-length"
        label="6+characters"
        :disabled="true"
        :model-value="!validation.minLength.$invalid"
        :small="true"
      ></form-checkbox>
      <form-checkbox
        class="password-requirements__letter"
        name="password-requirements-lower"
        label="Upper & Lower Case"
        :disabled="true"
        :model-value="hasOneUpperLower"
        :small="true"
      ></form-checkbox>
      <form-checkbox
        class="password-requirements__digit"
        name="password-requirements-digit"
        label="Number"
        :disabled="true"
        :model-value="!validation.hasOneDigit.$invalid"
        :small="true"
      ></form-checkbox>
    </div>
  </div>
</template>
<script src="./password-requirements.js"></script>
<style src="./password-requirements.scss" lang="scss"></style>
